var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticStyle:{"border-radius":"18px"},attrs:{"items":_vm.listOfGenders,"dense":"","hide-details":"","height":"52","background-color":"#eeeeee","solo":"","flat":""},model:{value:(_vm.genderModel),callback:function ($$v) {_vm.genderModel=$$v},expression:"genderModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }